/**
    * @description      : 
    * @author           : Saif
    * @group            : 
    * @created          : 04/11/2024 - 22:59:59
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 04/11/2024
    * - Author          : Saif
    * - Modification    : 
**/
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faEye, faCheck, faTimes, faFilter, faEdit, faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import CustomTable from "../../Components/CustomTable";
import CustomModal from "../../Components/CustomModal";

import CustomPagination from "../../Components/CustomPagination"
import CustomInput from "../../Components/CustomInput";
import CustomButton from "../../Components/CustomButton";


import "./style.css";
import { useGet, usePost } from "../../Api";
import { male1 } from "../../Assets/images";
import FormatDateTime from "../../Components/DateFormate";
import { useNotification } from '../../Components/GlobalNotification';
import PaymentModal from "../../Components/PaymentModal";

const getUserRole = () => {
  try {
    return String(JSON.parse(localStorage.getItem('userInfo') || '{}')?.role ?? '');
  } catch (e) {
    return '';
  }
};

const formatStatus = (value) => {
  if (!value) return '';
  return String(value).replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
};

export const ReservationManagement = () => {
  const { showNotification } = useNotification();

  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(30);
  const [inputValue, setInputValue] = useState('');
  const [reserveID, setReserveID] = useState(null);
  const [reserveCancelID, setReserveCancelID] = useState(null);
  const [payInvoice, setPayInvoice] = useState(null);
  const isGuest = getUserRole() === '3';
  const { ApiData: UseeListingData, loading: UseeListingLoading, error: UseeListingError, get: GetUseeListing } = useGet(`/reservations?per_page=200`);
  
  const { ApiData: ConfirmReservationData, loading: ConfirmReservationLoading, error: ConfirmReservationError, post: GetConfirmReservation } = usePost(`/reservations-confirmation/${reserveID}`);

  const { ApiData: CancelReservationData, loading: CancelReservationLoading, error: CancelReservationError, post: GetCancelReservation } = usePost(`/reservations-cancel/${reserveCancelID}`);


  const navigate = useNavigate();

  // confirm process 

  useEffect(() => {
    if (reserveID != null) {
      GetConfirmReservation('');
    }
  }, [reserveID])


  useEffect(()=>{
    if(ConfirmReservationData) {
        showNotification({ type: 'info', title: 'Information', message: ConfirmReservationData?.message });
        GetUseeListing();
    }
  },[ConfirmReservationData])


  // reject process 

  useEffect(() => {
    if (reserveCancelID != null) {
      GetCancelReservation('');
    }
  }, [reserveCancelID])


  useEffect(()=>{
    if(CancelReservationData) {
        showNotification({ type: 'info', title: 'Information', message: CancelReservationData?.message });
        GetUseeListing();
    }
  },[CancelReservationData])


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  console.log();

  const hanldeRoute = () => {
    navigate('/add-product')
  }


  const inActive = () => {
    setShowModal(false)
    setShowModal2(true)
  }
  const ActiveMale = () => {
    setShowModal3(false)
    setShowModal4(true)
  }

  const handleChange = (e) => {
    setInputValue(e.target.value);
  }

  const matchesSearch = (value, query) => {
    if (!query) return true;
    return String(value ?? "").toLowerCase().includes(query);
  };

  const filterQuery = inputValue.trim().toLowerCase();

  // Search only across specific reservation fields (not "all keys")
  const filterData = (Array.isArray(data) ? data : []).filter((item) => {
    if (!filterQuery) return true;

    return (
      matchesSearch(item?.id, filterQuery) ||
      matchesSearch(item?.reservation_id, filterQuery) ||
      matchesSearch(item?.listing_name, filterQuery) ||
      matchesSearch(item?.user?.name, filterQuery) ||
      matchesSearch(item?.user?.email, filterQuery) ||
      matchesSearch(item?.check_in, filterQuery) ||
      matchesSearch(item?.check_out, filterQuery) ||
      matchesSearch(item?.payment_status, filterQuery) ||
      matchesSearch(item?.confirmation_status, filterQuery) ||
      matchesSearch(item?.guests, filterQuery) ||
      matchesSearch(item?.subtotal, filterQuery) ||
      matchesSearch(item?.date, filterQuery)
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filterData.slice(indexOfFirstItem, indexOfLastItem);




  useEffect(() => {
    document.title = 'Kvr Reservation Management';
    GetUseeListing()

  }, []);


  useEffect(() => {
    if (UseeListingData) {
      setData(UseeListingData?.data?.data)
    }
  }, [UseeListingData])

  const upcomingHeader = [
    {
      key: "id",
      title: "S.No",
    },
    {
      key: "thumbnail",
      title: "Title",
    },
    {
      key: "username",
      title: "Name",
    },
    {
      key: "emai",
      title: "Email",
    },
    // {
    //   key: "read",
    //   title: "Address",
    // },
    {
      key: "status",
      title: "Guests",
    },

    {
      key: "created_at",
      title: "Check in",
    },
    {
      key: "action",
      title: "Check out",
    },
    {
      key: 'amount',
      title: 'Amount'
    },
    {
      key: 'date',
      title: 'Booked At'
    },
    {
      key: 'status',
      title: 'Payment Status'
    },
     {
      key: 'confirmation',
      title: 'Confirmation'
    },
    {
      key: 'actions',
      title: 'Actions'
    }
  ];

  const handleClosePayment = () => {
    setPayInvoice(null);
    GetUseeListing();
  };


  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <div className="row mb-3 justify-content-between">
                  <div className="col-md-6 mb-2">
                    <h2 className="mainTitle">Reservation Management</h2>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="addUser">
                      {/* <CustomButton text="Add New Product" variant='primaryButton' onClick={hanldeRoute} /> */}
                      <CustomInput type="text" placeholder="Search Here..." value={inputValue} inputClass="mainInput" onChange={handleChange} />
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-12">
                    <CustomTable
                      headers={upcomingHeader}

                    >
                      <tbody>
                        {currentItems?.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td><Link to={`/listing-detial/${item?.list_id}`}>{item?.listing_name}</Link></td>
                            <td className="text-capitalize">
                              {item?.user?.name}
                            </td>
                            <td>{item?.user?.email}</td>
                            {/* <td className="text-wrap">{item?.address}</td> */}
                            <td>{item?.guests}</td>
                            <td>{item?.check_in}</td>
                            <td>{item?.check_out}</td>
                            <td>{`$${item?.subtotal}`}</td>
                            <td>{item?.date}</td>
                            <td className="text-capitalize">{formatStatus(item?.payment_status)}</td>
                            <td className={`${item?.confirmation_status == '1' ? 'text-success' : 'text-danger'}`}>{item?.confirmation_status == '1' ? 'Confirmed' : 'Not Confirmed'}</td>
                            <td className="reservation-actions-cell">
                              <div className="reservation-actions">
                                <CustomButton
                                  text="View"
                                  variant="outline-primary"
                                  size="sm"
                                  icon={faEye}
                                  onClick={() => navigate(`/reservation-management/reservation-details/${item?.id}`)}
                                />
                                {isGuest && item?.invoice && item.invoice.status !== 'paid' && (
                                  <CustomButton
                                    text="Pay Now"
                                    variant="primary"
                                    size="sm"
                                    onClick={() => setPayInvoice({
                                      invoice_id: item.invoice.id,
                                      billing_for: item.invoice.billing_for,
                                      total: item.invoice.total,
                                    })}
                                  />
                                )}
                              </div>
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </CustomTable>
                    <CustomPagination
                      itemsPerPage={itemsPerPage}
                      totalItems={filterData?.length}
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <PaymentModal show={!!payInvoice} close={handleClosePayment} invoice={payInvoice} />

          <CustomModal show={showModal} close={() => { setShowModal(false) }} action={inActive} heading='Are you sure you want to mark this user as inactive?' />
          <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading='Marked as Inactive' />

          <CustomModal show={showModal3} close={() => { setShowModal3(false) }} action={ActiveMale} heading='Are you sure you want to mark this user as Active?' />
          <CustomModal show={showModal4} close={() => { setShowModal4(false) }} success heading='Marked as Active' />



        </div>
      </DashboardLayout>
    </>
  );
};
